import axios from '@store/axios'
import parseUrl from '@/core/helpers/parseUrl'

export default {
  getRequests({ commit }, { limit, offset, order, patients }) {
    commit('setLoadingRequests', true)
    let params = ''
    if (offset) {
      params = ', offset: ' + offset
    }
    params = params + ', order: "-id"'
    if (patients) {
      params = params + ', patients: ' + patients
      // params = params + ', provider: "' + search.provider + '"'
    }
    const statuses = '["-COMPLETED", "-CANCELLED"]'
    const query =
      `{ requests(statuses: ${statuses}, limit: ${limit}${params}) {
         items { 
          id,
          provider
          patient
          created 
          status
          log {
            timestamp
            message
          }
        }
        pageInfo {
          offset
          next
          count
          total
        } 
      } }`

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      let ret = data.data.requests
      let requests = []
      data.data.requests.items.forEach(request => {
        let requestObject = {}
        let d = new Date(request.created * 1000)
        let MyDateString =
          ('0' + (d.getMonth() + 1)).slice(-2) +
          '/' +
          ('0' + d.getDate()).slice(-2) +
          '/' +
          d.getFullYear()
        requestObject.createdDate = MyDateString
        requestObject.providerID = request.provider
        requestObject.patientID = request.patient
        if (request.log && request.log.length > 0) {
          requestObject.lastLog = request.log[request.log.length - 1].message
        }
        requestObject.status = request.status
        requestObject.id = request.id
        requests.push(requestObject)
      })
      commit('setRequestsPageInfo', ret.pageInfo)
      commit('setRequests', requests)
      commit('setLoadingRequests', false)
      return data
    })
      .catch(error => {
        let msg = {
          error: error
        }
        commit('setLoadingRequests', false)
        return msg
      })
  },
  getFiles({ commit }, { limit, offset, requestID }) {
    commit('setLoadingFiles', true)
    let params = ''

    if (offset) {
      params = ', offset: ' + offset
    }
    params = params + ', order: "-id"'
    if (requestID) {
      params = params + ', request: "' + requestID + '"'
    }
    if (!limit) {
      limit = 1000
    }

    // , offset: ${offset}
    const query =
      `{
        files(limit: ${limit}${params}) {
          items{
            id
            created
            faxedFrom
          }
          pageInfo {
            offset
            next
            count
            total
          }
        }
      }`
    // '{ files { id created recordType encounterDate originalFilename renderingProvider{id} patient{id firstName lastName} } }'

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      let ret = data.data.files
      commit('setFiles', ret.items)
      commit('setTotalItems', ret.pageInfo.total)
      commit('setPagination', [ret.pageInfo.count, ret.pageInfo.offset])
      commit('setLoadingFiles', false)
      return data
    })
      .catch(error => {
        let msg = {
          error: error
        }
        commit('setLoadingFiles', false)
        return msg
      })
  },
  sendProviderInvite({ commit }, { id }) {
    const url = parseUrl('/admin/providers/:id/invite', { id })
    return axios.post(url).then(({ data }) => {
      return data
    })
  },
  getRequest({ commit }, requestID) {
    console.log('get request')
    console.log(requestID)
    let id = requestID
    const url = parseUrl('/requests/:id', { id })
    return axios.get(url).then(({ data }) => {
      let selectedRequest = JSON.parse(data)
      selectedRequest.id = selectedRequest._id
      commit('setRequest', selectedRequest)
      return selectedRequest
    })
  },
  getRequestOld({ commit }, requestID) {
    const query =
      `{ 
        requests(id: "${requestID}") {
          items {
            id
            created
            end
            start
            status
            missingProviderInfo
            provider {
              id 
              notes 
              address {
                line1 
                city 
                state 
                zip
              } 
            fax 
            email 
            phone 
            firstName 
            lastName 
            credentials 
            type 
            organizationName
            googlePlaceID
            npi
            } 
            patient {
              id 
              partner {
                id
                name
              }
              birthdate
              firstName
              lastName 
              address {
                line1 
                line2 
                city 
                state 
                zip 
              }
            } 
            log {
              timestamp 
              message
            }
          }
        } 
      }`

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setRequest', data.data.requests.items[0])
      return data.data.requests.items[0]
    })
  },
  getRequestProvider({ commit }, requestID) {
    const query =
      `{
        requests(id: "${requestID}") {
          items {
            provider {
              id
              notes
              address {
                line1
                city
                state
                zip
              }
              fax 
              email 
              phone 
              firstName 
              lastName 
              credentials 
              type 
              organizationName
              googlePlaceID
              npi
            }
          }
        }
      }`

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setRequestProvider', data.data.requests.items[0].provider)
      return data.data.requests.items[0].provider
    })
  },
  // TODO: This isn't being used anywhere right now
  getUploads({ commit, dispatch }) {
    return axios.get('/admin/db/uploads').then(({ data }) => {
      // for (let i = 0; data.length > i; i++) {
      //   dispatch('getPatient', { id: data[i].patient }).then(patient => {
      //     data[i].patient = patient
      //   })
      // }
      commit('setUploads', data)
    })
  },
  setProviderInfo({ commit }, { id, info }) {
    const url = parseUrl('/admin/db/provider/:id', { id })
    return axios.patch(url, info).then(({ data }) => {
      commit('setProvider', data)
    })
  },
  setFileInfo({ commit }, { file, id }) {
    const url = parseUrl('/admin/file/:id', { id })
    return axios.patch(url, file).then(({ data }) => {
      commit('setFile', data)
    })
  },
  // TODO: Not being used
  createProvider({ commit }, provider) {
    return axios.post('/admin/db/provider', provider).then(({ data }) => {
      commit('setProvider', data)
      return data
    })
  },
  getDocumentFiles({ commit }, { requestID }) {
    let params = ''

    if (requestID) {
      params = params + ' request: "' + requestID + '"'
    }

    // , offset: ${offset}
    const query =
      `{
        files(${params}) {
          items{
            id
            faxedFrom
            created
            recordType
            encounterDate
            originalFilename
            mimetype
            renderingProvider {
              firstName
              lastName
              credentials
            }
            patient {
              firstName
              lastName
            }
            description
          }
        }
      }`
    // '{ files { id created recordType encounterDate originalFilename renderingProvider{id} patient{id firstName lastName} } }'

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      let ret = data.data.files
      commit('setFiles', ret.items)
      return data
    })
  },
  openFile({ commit }, file) {
    let authToken = null
    file._id = file.id
    switch (file.mimetype) {
      case 'application/dicom+zip':
        let url = 'https://api.onecharthealth.com/files/' + file._id + '/dicom_urls?alt=presign'
        if (authToken) {
          url = url + '&auth_bearer=' + authToken
        }
        return axios.get(url).then(({ data }) => {
          window.open('https://onechart-clinical-viewer.firebaseapp.com' + '?id=' + file._id + '&jwt=' + encodeURIComponent(data.presign_jwt))
        })
      case 'application/pdf':
        url = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media'
        if (authToken) {
          url = url + '&auth_bearer=' + authToken
        }
        return axios.get(url).then(({ data }) => {
          // const preSignedRequest = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media&presign_jwt=' + data.presign_jwt
          window.open(process.env.PDF_VIEWER_URL + '?file=' + encodeURIComponent(data.download_url))
        })
        // url = 'https://api.onecharthealth.com/files/' + file._id + '?alt=presign'
        // if (authToken) {
        //   url = url + '&auth_bearer=' + authToken
        // }
        // return axios.get(url).then(({ data }) => {
        //   const preSignedRequest = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media&auth_bearer=' + data.presign_jwt
        //   window.open(process.env.PDF_VIEWER_URL + '?file=' + encodeURIComponent(preSignedRequest))
        // })
      default:
        // Ignore
        url = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media'
        if (authToken) {
          url = url + '&auth_bearer=' + authToken
        }
        return axios.get(url).then(({ data }) => {
          // const preSignedRequest = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media&presign_jwt=' + data.presign_jwt
          window.open(process.env.PDF_VIEWER_URL + '?file=' + encodeURIComponent(data.download_url))
        })
    }
  },
  getFile({ commit }, fileId) {
    const query =
      `{
        files(id: "${fileId}") {
          items{
            id
            created
            recordType
            encounterDate
            originalFilename
            mimetype
            downloadURL
            accessToken
            description
          }
          pageInfo {
            offset
            next
            count
            total
          }
        }
      }`
    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setFile', data.data.files.items)
      return data
    })
  },
  searchForPatient({ commit }, { firstName, lastName }) {
    // Split into a first and last name, separated by a comma
    let query

    if (firstName.length > 0 && lastName.length > 0) {
      query =
        '{ patients(firstName: "' +
        firstName +
        '" lastName: "' +
        lastName +
        '") { items { id firstName lastName birthdate } } }'
    } else if (firstName.length > 0 && !(lastName.length > 0)) {
      query =
        '{ patients(firstName: "' +
        firstName +
        '") { items { id firstName lastName birthdate } } }'
    } else if (!(firstName.length > 0) && lastName.length > 0) {
      query =
        '{ patients(lastName: "' +
        lastName +
        '") { items { id firstName lastName birthdate } } }'
    } else {
      return
    }

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setPatientSearchResults', data.data.patients.items)
      return data.data.patients.items
    })
  },
  fuzzySearchForPatient({ commit }, { firstName, lastName }) {
    // Split into a first and last name, separated by a comma
    let query

    query =
      '{ patients(lastName: "' +
      lastName +
      '") { items { id firstName lastName birthdate gender phone address{line1 line2 city state zip} } } }'

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      data.data.patients.items.forEach(patient => {
        patient.fullName = patient.firstName + ' ' + patient.lastName
        let d = new Date(patient.birthdate * 1000)
        patient.birthdateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear()
      })

      commit('setPatientSearchResults', data.data.patients.items)
      return data.data.patients.items
    })
  },
  getPatientList({ commit }) {
    // Split into a first and last name, separated by a comma
    let query = '{ patients { items { id birthdate gender firstName lastName phone address{line1 line2 city state zip} partner{id} created creator{id email firstName lastName created} } } }'

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setPatientSearchResults', data.data.patients.items)
      return data.data.patients.items
    })
  },
  getProvidersList({ commit }) {
    // Split into a first and last name, separated by a comma
    let query = '{ providers { items { id firstName lastName credentials organizationName npi specialization type googlePlaceID notes fax email phone affiliateCode address{line1 city state zip } } } }'

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setProviderSearchResults', data.data.providers.items)
      return data.data.providers.items
    })
  },
  getUserList({ commit }) {
    // Split into a first and last name, separated by a comma
    let query = '{ users { items { id email created } } }'

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setUserSearchResults', data.data.users.items)
      return data.data.users.items
    })
  },
  getRecordTypes({ commit }) {
    return axios.get('/public/files/record_types').then(data => {
      commit('setRecordTypes', data)
      return data
    })
  },
  postUserGroup({ commit }, { name, provider }) {
    return axios.post('/admin/user_groups', { name, provider }).then(data => {
      // Note, no commit needed for now
      return data
    })
  },
  getUserGroups({ commit }, { limit, offset }) {
    let params = ''
    if (offset) {
      params = ', offset: ' + offset
    }

    const query =
      `{
      userGroups(limit: ${limit}${params}) {
        items {
          id
          name
          created
        }
        pageInfo {
          count
          offset
          next
          total
        }
      }
    }`
    return axios.post('/admin/gql', { query }).then(({ data }) => {
      let slimmed = []
      data.data.userGroups.items.forEach(group => {
        if (!group.name.includes('Staff for')) {
          slimmed.push(group)
        }
      })
      commit('setGroups', slimmed)
      commit('setGroupsPageInfo', data.data.userGroups.pageInfo)
      return data
    })
  },
  submitUserGroup({ commit }, { name, provider }) {
    let payload = { name: name }
    if (provider) {
      payload.provider = provider
    }
    return axios.post('/admin/user_groups', payload).then(({ data }) => {
      return data
    })
  },
  sendRequest({ commit }, { id }) {
    const url = parseUrl('/admin/requests/:id/send', { id })
    return axios.post(url).then(({ data }) => {
      return data
    })
  },
  getRequestOverrides({ commit }, { id }) {
    const query = `
    {
      requests (id: "${id}") {
        items {
          id
          providerAddressOverride {
            city
            line1
            line2
            state
            zip
          }
          providerFaxOverride
          providerEmailOverride
          providerPhoneOverride
          providerNameOverride
        }
      }
    }
    `
    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setRequestProviderOverrides', data.data.requests.items[0])
      return data
    })
  },
  submitRequestOverrides({ commit }, { id, provider }) {
    const overrides = {
      providerNameOverride: provider.name,
      providerAddressOverride: provider.address,
      providerEmailOverride: provider.email,
      providerFaxOverride: provider.fax,
      providerPhoneOverride: provider.phone
    }

    const url = parseUrl('/admin/requests/:id', { id })
    return axios.patch(url, overrides).then(({ data }) => {
      return data
    })
  },
  updateFaxOrEmail({ commit }, { id, fax, email }) {
    const overrides = {
      providerFaxOverride: fax,
      providerEmailOverride: email
    }
    const url = parseUrl('/admin/requests/:id', { id })
    return axios.patch(url, overrides).then(({ data }) => {
      return data
    })
  },
  submitRequestNote({ commit }, { id, notes, note }) {
    notes.push(note)
    const url = parseUrl('/admin/requests/:id', { id })
    return axios.patch(url, { log: notes }).then(({ data }) => {
      console.log(data)
      return data
    })
  },
  setStatus({ commit }, { id, status }) {
    const url = parseUrl('/admin/requests/:id', { id })
    return axios.patch(url, status).then(({ data }) => {
    })
  },
  getPatients({ commit }, { id, firstName, lastName, DOB }) {
    let params = ''
    if (id && id !== '') {
      params = params + 'id: "' + id + '", '
    }
    if (firstName && firstName !== '') {
      params = params + 'firstName: "' + firstName + '", '
    }
    if (lastName && lastName !== '') {
      params = params + 'lastName: "' + lastName + '", '
    }
    if (DOB & DOB !== '') {
      params = params + 'birthdate: "' + DOB + '", '
    }
    const query = `
    {
      patients (${params} limit: 30) {
        items{
          firstName
          lastName
          id
          birthdate
          gender
        }
      }
    }
    `

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setPatientSearchResults', data.data.patients.items)
      return data.data.patients.items
    })
  },
  getPatient({ commit }, { id }) {
    let params = ''
    if (id && id !== '') {
      params = params + 'id: "' + id + '", '
    }
    const query = `
    {
      patients (${params}) {
        items{
          firstName
          lastName
          id
          birthdate
          gender
        }
      }
    }
    `

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setPatient', data.data.patients.items[0])
      return data.data.patients.items[0]
    })
  },
  viewFile({ commit }, fileID) {
    let url = 'https://api.onecharthealth.com/admin/files/' + fileID + '?alt=media'
    return axios.get(url).then(({ data }) => {
      // const preSignedRequest = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media&presign_jwt=' + data.presign_jwt
      return 'https://onechart-pdf-viewer.firebaseapp.com/' + '?file=' + encodeURIComponent(data.download_url)
    })
  },
  getPatientRequests({ commit }, { patientID }) {
    const statuses = '["-CANCELLED"]'
    const query = `
    {
      requests (patient: "${patientID}", statuses: ${statuses}) {
        items {
          id
          start
          end
          provider
          providerAddressOverride {
            city
            line1
            line2
            state
            zip
          }
          providerFaxOverride
          providerEmailOverride
          providerPhoneOverride
          providerNameOverride
        }
      }
    }
    `

    return axios.post('/admin/gql', { query }).then(({ data }) => {
      console.log('patient requests back')
      console.log(data.data.requests.items)
      commit('setPatientRequest', data.data.requests.items)
      return data.data.requests.items
    })
  },
  getDocumentProvider({ commit }, { id }) {
    const query = `
    {
      providers (id: "${id}") {
        items {
          id
          firstName
          lastName
          organizationName
        }
      }
    }
    `
    return axios.post('/admin/gql', { query }).then(({ data }) => {
      commit('setDocumentProvider', data.data.providers.items[0])
      return data.data.providers.items[0]
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/actions.js